import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, type AuthRole } from '../auth/AuthContext';

interface ProtectedRouteProps {
  allowedRole: AuthRole;
}

export default function ProtectedRoute({ allowedRole }: ProtectedRouteProps) {
  const location = useLocation();
  const { configured, loading, user, role } = useAuth();

  if (!configured) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-surface-50 flex items-center justify-center px-4">
        <div className="text-sm font-medium text-surface-600">Checking your session...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (role !== allowedRole) {
    return <Navigate to={role === 'admin' ? '/admin' : '/dashboard'} replace />;
  }

  return <Outlet />;
}
